export interface IEmployeeRecord {
  id: number;
  lastName: string;
  firstName: string;
  middleName: string | null;
  employeeId: string;
  facility: string;
  application: string;
  [key: string]: unknown;
}

export const employees: IEmployeeRecord[] = [
  {
    id: 1,
    lastName: "Johnson",
    firstName: "Emily",
    middleName: "Rose",
    employeeId: "EMP-10421",
    facility: "Main Campus",
    application: "Lawson HR",
  },
  {
    id: 2,
    lastName: "Johnson",
    firstName: "Michael",
    middleName: null,
    employeeId: "EMP-10486",
    facility: "Main Campus",
    application: "Lawson HR",
  },
  {
    id: 3,
    lastName: "Garcia",
    firstName: "Sofia",
    middleName: "Marie",
    employeeId: "EMP-10547",
    facility: "East Emergency",
    application: "PeopleSoft HCM",
  },
  {
    id: 4,
    lastName: "Chen",
    firstName: "Wei",
    middleName: null,
    employeeId: "EMP-10612",
    facility: "Main Campus",
    application: "PeopleSoft HCM",
  },
  {
    id: 5,
    lastName: "Williams",
    firstName: "David",
    middleName: "Allen",
    employeeId: "EMP-10688",
    facility: "East Emergency",
    application: "Lawson HR",
  },
  {
    id: 6,
    lastName: "Brown",
    firstName: "Jessica",
    middleName: null,
    employeeId: "EMP-10754",
    facility: "Main Campus",
    application: "Lawson HR",
  },
];

export interface EmployeeSearchCriteria {
  firstName?: string | null;
  lastName?: string | null;
  employeeId?: string | null;
}

const normalize = (s?: string | null) => (s ?? "").trim().toLowerCase();

export const searchEmployees = (
  criteria: EmployeeSearchCriteria,
): Promise<IEmployeeRecord[]> =>
  new Promise((resolve) => {
    // simulated API latency
    setTimeout(() => {
      const first = normalize(criteria.firstName);
      const last = normalize(criteria.lastName);
      const employeeId = normalize(criteria.employeeId);

      resolve(
        employees.filter((e) => {
          if (first && !e.firstName.toLowerCase().includes(first)) return false;
          if (last && !e.lastName.toLowerCase().includes(last)) return false;
          if (employeeId && !e.employeeId.toLowerCase().includes(employeeId))
            return false;
          return true;
        }),
      );
    }, 400);
  });
